import { useState } from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

export type ImportingFileType = {
  completed: boolean;
  file: File;
};

interface CancelImportImageButtonProps {
  importingFiles: ImportingFileType[];
  importImagesRef: React.MutableRefObject<{
    abortted?: boolean;
    abortController?: AbortController;
  }>;
}

const CancelImportImageButton: React.FC<CancelImportImageButtonProps> = ({ importingFiles, importImagesRef }) => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleSubmit = () => {
    importImagesRef.current.abortted = true;
    importImagesRef.current.abortController?.abort();
    setOpenDialog(false);
  };

  const cancelCount = importingFiles.filter(f => !f.completed).length;
  const totalCount = importingFiles.length;

  if (!cancelCount) return null;

  return (
    <>
      <Button variant="text" onClick={() => setOpenDialog(true)} color="secondary">
        Avbryt uppladdningen
      </Button>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>
          Vill du avbryta uppladdningen av {cancelCount} av {totalCount} filer?
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gridGap: 6 }}>
            {importingFiles.map(({ completed, file }) => {
              return (
                <Box key={file.name} sx={{ display: 'flex', alignItems: 'center', gridGap: 6 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 10, pt: '4px' }}>
                    {completed ? '✅' : '❌'}
                  </Box>
                  <Box>
                    {file.name} — ({completed ? 'Uppladdad, avbryts ej' : 'Ej slutförd, avbryts'})
                  </Box>
                </Box>
              );
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display="flex" gridGap={16} px={2} py={1}>
            <Button size="small" onClick={handleSubmit} color="secondary" variant="contained">
              Ja, avbryt uppladdningen
            </Button>
            <Button size="small" onClick={() => setOpenDialog(false)} color="primary" variant="outlined">
              Behåll uppladdningen
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CancelImportImageButton;
